const workingCalendar = {
    'TITLE': 'Working Calendar',
    'CREATE': 'Tạo',
    'IMPORT': 'Nhập',
    'EXPORT': 'Xuất',
    'PARTNER_NAME': 'Tên đối tác',
    'TYPE': 'Loại',
    'WORKING_DAYS': 'Ngày làm việc',
    'NON_WORKING_DAYS': 'Ngày nghỉ',
    'HOLIDAY_CALENDAR': 'Lịch nghỉ lễ',
    'STATUS': 'Trạng thái',
    'UPDATE_BY': 'Cập nhật bởi',
    'UPDATE_AT': 'Cập nhật lúc',
    'ACTION': 'Hành động',
    'ACTIVE': 'Hoạt động',
    'INACTIVE': 'Không hoạt động',
    'HOLIDAYS': 'ngày lễ',
    'SEARCH': 'Tìm kiếm',
    'TYPE_PLACEHOLDER': 'Loại',
    'CREATE_TITLE': 'Tạo Working Calendar',
    'EDIT_TITLE': 'Sửa Working Calendar',
    'GENERAL_INFO': 'Thông tin chung',
    'ADD_HOLIDAY': 'Thêm ngày lễ',
    'HOLIDAY_NAME': 'Tên ngày lễ',
    'DATE': 'Ngày',
    'REPEAT_YEARLY': 'Lặp hàng năm',
    'YES': 'Có',
    'SELECT_PLACEHOLDER': 'Chọn...',
    'DATE_RANGE_PLACEHOLDER': 'dd/mm/yyyy - dd/mm/yyyy',
    'INPUT_PLACEHOLDER': 'Nhập...',
    'SAVE_ROW': 'Lưu',
    'NO': 'Không',
};

export default workingCalendar;
